"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return GridView;
    }
});
const _GridViewColumn = /*#__PURE__*/ _interop_require_default(require("~/models/GridViewColumn"));
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
const _modelUtils = require("~/utils/modelUtils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let GridView = class GridView {
    async getColumns(context) {
        return this.columns = await _GridViewColumn.default.list(context, this.fk_view_id);
    }
    static async get(context, viewId, ncMeta = _Noco.default.ncMeta) {
        let view = viewId && await _NocoCache.default.get(context, `${_globals.CacheScope.GRID_VIEW}:${viewId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!view) {
            view = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.GRID_VIEW, {
                fk_view_id: viewId
            });
            await _NocoCache.default.set(context, `${_globals.CacheScope.GRID_VIEW}:${viewId}`, view);
        }
        return view && new GridView(view);
    }
    static async insert(context, view, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(view, [
            'fk_view_id',
            'base_id',
            'source_id',
            'row_height'
        ]);
        const viewRef = await _View.default.get(context, insertObj.fk_view_id, ncMeta);
        if (!insertObj.source_id) {
            insertObj.source_id = viewRef.source_id;
        }
        await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.GRID_VIEW, insertObj, true);
        return this.get(context, view.fk_view_id, ncMeta);
    }
    static async getWithInfo(context, id, ncMeta = _Noco.default.ncMeta) {
        const view = await this.get(context, id, ncMeta);
        return view;
    }
    static async update(context, viewId, body, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(body, [
            'row_height',
            'meta'
        ]);
        // update meta
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.GRID_VIEW, (0, _modelUtils.prepareForDb)(updateObj), {
            fk_view_id: viewId
        });
        await _NocoCache.default.update(context, `${_globals.CacheScope.GRID_VIEW}:${viewId}`, (0, _modelUtils.prepareForResponse)(updateObj));
        return res;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
